"use client"

import { usePathname } from 'next/navigation';
import React from 'react'
import { useSelector } from 'react-redux';

// Page frame for the public routes. It used to gate `children` behind an
// `is404` flag that started as `true` and was only cleared in a browser-side
// effect, so the server rendered an empty frame for every page (see
// dashboard-layout/Layout.jsx for the full story). Everything here can be
// derived synchronously, so the server and the first client render agree.
const NotFound = ({ children }) => {
	const pathname = usePathname()
	const fullscreenRoutes = [
		"/reps/registration",
	]
	const isSpecialRoute = fullscreenRoutes.includes(pathname)
	// The two-factor code screens render no site header, so they don't need the
	// top offset reserved for it. They are shown before the user is logged in.
	const noHeaderRoutes = [
		"/provider/two-factor-verification",
		"/reps/two-factor-verification",
		"/reps/accept-invite",
		"/reps/work-details",
	]
	const reserveHeaderSpace = !noHeaderRoutes.includes(pathname)

	// Get user data from Redux store
	const userData = useSelector((state) => state?.userData?.userData?.user);
	// Check if user is logged in
	const isLoggedIn = userData && userData._id;
	return <>
		<div className={isSpecialRoute ?
			"h-screen w-screen bg-white" :
			`bg-[#F5F6F5] overflow-y-auto z-10 ${!isLoggedIn && reserveHeaderSpace ? "pt-[100px]" : ""}`
		}>
			{children}
		</div>
	</>
}

export default NotFound
